import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookTotalsTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          totals: {},
        };
        this.edit = this.edit.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.totals !== 'undefined' && newProps.totals !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            totals: newProps.totals,
          });
        }
      }
    
      // Fetch salvando a edição
      edit(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '#', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    
      render() {
        return (
    <div>
      <RequestApi ref={'request_api'} />
        <h3 className="page-title pull-left">Totals</h3>
        <div className="clearfix"></div>
        <hr/>
        <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
                <thead>
                  <tr className="text-center">
                    <th>Counter</th>
                    <th>ACFT FH</th>
                    <th>ACFT FH (decimal)</th>
                    <th>ACFT LDG</th>
                    <th>ENG #1 FH</th>
                    <th>ENG #2 FH</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-center">
                    <td>Previous</td>
                    <td>{this.state.totals.previous_logbook_aircraft_flight_hours_str}</td>
                    <td>{this.state.totals.previous_logbook_aircraft_flight_hours_decimal}</td>
                    <td>{this.state.totals.previous_logbook_aircraft_landings}</td>
                    <td>{this.state.totals.previous_logbook_engine_1_flight_hours_str}</td>
                    <td>{this.state.totals.previous_logbook_engine_2_flight_hours_str}</td>
                  </tr>
                  <tr className="text-center">
                    <td>Actual</td>
                    <td>{this.state.totals.actual_logbook_aircraft_flight_hours_str}</td>
                    <td>{this.state.totals.actual_logbook_aircraft_flight_hours_decimal}</td>
                    <td>{this.state.totals.actual_logbook_aircraft_landings}</td>
                    <td>{this.state.totals.actual_logbook_engine_1_flight_hours_str}</td>
                    <td>{this.state.totals.actual_logbook_engine_2_flight_hours_str}</td>
                  </tr>
                  <tr className="text-center">
                    <td>Total</td>
                    <td>{this.state.totals.total_aircraft_flight_hours_str}</td>
                    <td>{this.state.totals.total_aircraft_flight_hours_decimal}</td>
                    <td>{this.state.totals.total_aircraft_landings}</td>
                    <td>{this.state.totals.total_engine_1_flight_hours_str}</td>
                    <td>{this.state.totals.total_engine_2_flight_hours_str}</td>
                  </tr>
                </tbody>
            </table>
        </div>
    </div>
    );
  }
}

export default AircraftLogbookTotalsTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookTotalsTab.js